const StatusCell: React.FC<{ status: string }> = ({ status }) => {
  const findStatus = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'in-progress':
        return 'กำลังดำเนินการ'
      case 'denied':
        return 'ไม่อนุมัติ'
      case 'approved':
        return 'อนุมัติ'
      case 'pending':
        return 'รอดำเนินการ'
      default:
        return ''
    }
  }

  const findColor = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'pending':
        return 'badge-warning'
      case 'in-progress':
        return 'badge-primary'
      case 'denied':
        return 'badge-danger'
      case 'approved':
        return 'badge-success'
      default:
        return ''
    }
  }

  return (
    <>
      {status && status.toLowerCase() !== '' ? (
        <span className={`badge ${findColor(status)}`}>{findStatus(status)}</span>
      ) : (
        '-'
      )}
    </>
  )
}

export default StatusCell
